define(
    'atn/dataCache',['lodash', 'knockout', './globals', 'common/browserFeatureSupport'],
    function(_, ko, globals, browserFeatureSupport) {
    
    'use strict';
    var dataRegistryList = ko.observableArray([]);

    globals.reInitAt.subscribe(function() {
        clean();
    });

    var privateDataStorageObject = {};

    return {
        addRegistry: addDataRegistry,
        clean: clean,
        setLocalStorageVariable: setLocalStorageVariable,
        getLocalStorageVariable: getLocalStorageVariable,
        removeLocalStorageVariable:removeLocalStorageVariable
    };

    function clean() {
        _.each(dataRegistryList(), function(obs) {
            var data = obs();
            if (_.isArray(data)) {
                obs([]);
            } else if (_.isObject(data)) {
                obs({});
            }
        });
    }

    function addDataRegistry(dataObs) {
        if (_.isArray(dataObs)) {
            _.each(dataObs, function(data) {
                dataRegistryList.push(data);
            });
        } else {
            dataRegistryList.push(dataObs);
        }
    }

    function setLocalStorageVariable(key,value){
        if(browserFeatureSupport.isLocalStorageSupported()){
            window.localStorage[key] = value;
        } else {
             privateDataStorageObject[key] = value;
        }
    }

    function getLocalStorageVariable(key){
        var returnStorageVariable;

        if(browserFeatureSupport.isLocalStorageSupported()){
            returnStorageVariable = window.localStorage[key];
        } else {
            returnStorageVariable = privateDataStorageObject[key];
        }
        return returnStorageVariable;
    }

    function removeLocalStorageVariable(key){

        if(browserFeatureSupport.isLocalStorageSupported()){
            delete window.localStorage[key];
        } else {
            delete privateDataStorageObject[key];
        }
    }
});
